import { Tooltip } from 'antd';
import psutLogo from '../../assets/images/psut-logo.png';

export const PSUTMark = () => (
	<Tooltip title="">
		<img style={{ height: '25px', width: 'auto' }} src={psutLogo} />
	</Tooltip>
);
